import React from "react";

import { EnhancedTableBody } from "../EnhancedTableBody";
import { PlacementWorksheetTableBodyRow } from "./PlacementWorksheetTableBodyRow";
import { IPlacementWorksheetUnit } from "../../services/PlacementWorksheetApi";
import { PlacementWorksheetTableRowProvider } from "./PlacementWorksheetTableRowContext";
import { usePlacementWorksheetSettingsContext } from "../../contexts/PlacementWorksheetContext";

// Todo: update types
interface IPlacementWorksheetTableBodyProps {
  rows: IPlacementWorksheetUnit[];
  onRowSelect: (id: number) => void;
  selectedRows: number[];
  isLoading?: boolean;
  isReadOnly?: boolean;
  matchGroupAtLimit: boolean;
}

export const PlacementWorksheetTableBody: React.FC<IPlacementWorksheetTableBodyProps> = ({
  rows,
  selectedRows,
  onRowSelect,
  isReadOnly,
  isLoading,
  matchGroupAtLimit,
}) => {
  const { labels } = usePlacementWorksheetSettingsContext();
  // Calculate colSpan: 7 (original columns) - 1 (removed Residents column) + labels.length (individual room columns)
  const colSpan = 6 + (labels?.length || 0);

  // Track horizontal scroll state
  const [isScrolled, setIsScrolled] = React.useState(false);

  // Add scroll event listener to detect horizontal scrolling
  React.useEffect(() => {
    const handleScroll = (e: Event) => {
      if (e.target instanceof HTMLElement) {
        setIsScrolled(e.target.scrollLeft > 5);
      }
    };

    // Find the scrollable container
    const scrollContainer = document.querySelector('.table-scroll-container');
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);
      return () => scrollContainer.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <EnhancedTableBody colSpan={colSpan} isLoading={isLoading}>
      {rows.map((row, i) => (
        <PlacementWorksheetTableRowProvider key={i}>
          <PlacementWorksheetTableBodyRow
            data={row}
            isSelected={selectedRows.includes(row.unitId)}
            onSelect={() => onRowSelect(row.unitId)}
            isReadOnly={isReadOnly}
            matchGroupAtLimit={matchGroupAtLimit}
            index={i}
            isScrolled={isScrolled}
          />
        </PlacementWorksheetTableRowProvider>
      ))}
    </EnhancedTableBody>
  );
};
